import {CheckCircleOutlined} from '@mui/icons-material';
import {Chip, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';

import {FONT_FAMILIES} from '../../../../../const';
import {productShape} from '../../../../../proptypes-shapes';

const ProductDescription = ({product}) => {
  return (
    <Grid item xs={12} lg={6}>
      <Typography fontFamily={FONT_FAMILIES.TITLE} fontSize={25} mb={0.5}>
        {product.name}
      </Typography>
      <Typography fontSize={14} mb={1.5} color="text.secondary">
        {product.description}
      </Typography>
      <Grid container>
        {product.marketing_features.map((feat, i) => (
          <Chip
            sx={{
              height: 'auto',
              mr: 1,
              mb: 1,
              fontStyle: 'italic',
              fontSize: 12,
              '& .MuiChip-label': {
                display: 'block',
                whiteSpace: 'normal'
              }
            }}
            data-testid="chip"
            icon={<CheckCircleOutlined />}
            size="small"
            key={i}
            label={feat.name}
          />
        ))}
      </Grid>
    </Grid>
  );
};

ProductDescription.propTypes = {
  product: productShape.isRequired
};

export default ProductDescription;
